import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import {
  faUser,
  faVideoCamera,
} from '@fortawesome/free-solid-svg-icons';
import {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { useUserContext } from '../contexts/UserContext';

import { URLContext } from '../contexts/URLContext';
import { CategoriesContext } from '../contexts/CategoriesContext';
import Category from '../models/Category/Category';

interface Props {
  open: boolean
  handleLogoutModalOpen: () => void
}

const systemBLocksManagementRelease = true;
const imageManagementRelease = false;

const SideBar = ({ open, handleLogoutModalOpen }: Props) => {
  const location = useLocation();
  const { categoryId, setCategoryId } = useContext(URLContext);
  const [blocksMenuOpen, setBlocksMenuOpen] = useState(false);
  const [imagesMenuOpen, setImagesMenuOpen] = useState(false);
  const [blocksImageMenuOpen, setBlocksImageMenuOpen] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const isActive = (path: string, _categoryId?: string) => {
    if (categoryId == null) {
      return (location.pathname === path ? 'active' : '');
    }
    return (location.pathname === path && categoryId === _categoryId ? 'active' : '');
  };

  const isImageManagementActive = useCallback((path: string) => (location.pathname === path ? 'active' : ''), [location.pathname]);

  const { userCan } = useUserContext();
  const { requestAllCategory } = useContext(CategoriesContext);

  useEffect(() => {
    requestAllCategory().then((data) => {
      setCategories(data);
    });
  }, [requestAllCategory]);

  return (
    <nav id="sidebar" className="sidebar js-sidebar" style={{ marginLeft: open ? '0px' : '-260px' }}>
      <div className="sidebar-content js-simplebar">
        <Link className="sidebar-brand text-center" to="/" style={{ height: '65px', background: '#fff' }}>
          <img src="img/logo_admin2.png" alt="ビルドセルフ - BUILD-SELF" className="img-fluid" width="200" />
        </Link>
        <ul className="sidebar-nav" style={{ overflow: 'auto' }}>
          <li className="sidebar-header">
            メインメニュー
          </li>
          <li className={`sidebar-item ${isActive('/')}`}>
            <Link className="sidebar-link" to="/">
              <i className="fa-solid fa-house fa-fw" />
              {' '}
              <span className="align-middle">ホーム</span>
            </Link>
          </li>
          <li className="sidebar-header py-0"><hr /></li>

          <li className="sidebar-header pt-0">
            管理
          </li>

          <li className={`sidebar-item  ${isActive('/category-management')}`}>
            <Link to="/category-management" className="sidebar-link">
              <i className="fa-solid fa-pen-to-square fa-fw" />
              <span className="align-middle">カテゴリ管理</span>
            </Link>
          </li>

          <li hidden={!systemBLocksManagementRelease} className={`sidebar-item ${isActive('/system-blocks-management')}`}>
            <a onClick={() => setBlocksMenuOpen((o) => !o)} data-bs-target="#menu-blocks" data-bs-toggle="collapse" className="sidebar-link" aria-expanded="true">
              <i className="fa-solid fa-cubes fa-fw" />
              <span className="align-middle">ブロック管理</span>
            </a>
            <Collapse in={blocksMenuOpen} timeout="auto" unmountOnExit>
              <ul id="menu-blocks" className="sidebar-dropdown list-unstyled collapse show" data-bs-parent="#sidebar">
                <li className={`sidebar-item ${isActive('/system-blocks-management', '')}`}><Link onClick={() => setCategoryId('')} className="sidebar-link" to="/system-blocks-management">全てのブロック</Link></li>
                {categories.map((category) => (<li key={category.id} className={`sidebar-item ${isActive('/system-blocks-management', category.id)}`}><Link onClick={() => setCategoryId(category.id)} className="sidebar-link" to="/system-blocks-management">{category.title}</Link></li>))}
              </ul>
            </Collapse>
          </li>

          <li hidden={!imageManagementRelease} className="sidebar-item">
            <a onClick={() => setBlocksImageMenuOpen((o) => !o)} data-bs-target="#menu-images" data-bs-toggle="collapse" className="sidebar-link" aria-expanded="false">
              <i className="fa-regular fa-image fa-fw" />
              <span className="align-middle">画像管理</span>
            </a>
            <Collapse in={blocksImageMenuOpen} timeout="auto" unmountOnExit>
              <ul id="menu-images" className="sidebar-dropdown list-unstyled show" data-bs-parent="#sidebar">
                {userCan('system-block') && <li className="sidebar-item"><Link className={`sidebar-link ${isActive('/system-blocks-management')}`} to="/system-images-management">システム画像</Link></li>}
                <li className="sidebar-item"><Link className={`sidebar-link ${isActive('/blocks-images-management')}`} to="/blocks-images-management">ブロック画像</Link></li>
              </ul>
            </Collapse>
          </li>

          <li className={`sidebar-item  ${isActive('/user-management')}`}>
            <Link to="/user-management" className="sidebar-link">
              <FontAwesomeIcon icon={faUser} />
              <span className="align-middle">ユーザー管理</span>
            </Link>
          </li>
          <li
            // hidden={!systemBLocksManagementRelease}
            className="sidebar-item"
          >
            <a onClick={() => setImagesMenuOpen((o) => !o)} data-bs-target="#menu-images" data-bs-toggle="collapse" className="sidebar-link" aria-expanded="true">
              <i className="fa-regular fa-image fa-fw" />
              <span className="align-middle">画像管理</span>
            </a>
            <Collapse in={imagesMenuOpen} timeout="auto" unmountOnExit>
              <ul id="menu-images" className="sidebar-dropdown list-unstyled collapse show" data-bs-parent="#sidebar">
                <li
                  className={`sidebar-item ${isImageManagementActive('/blocks-images-management')}`}
                >
                  <Link
                    className="sidebar-link"
                    to="/blocks-images-management"
                  >
                    ブロック画像
                  </Link>
                </li>
                <li
                  className={`sidebar-item ${isImageManagementActive('/system-images-management')}`}
                >
                  <Link
                    className="sidebar-link"
                    to="/system-images-management"
                  >
                    システム画像
                  </Link>
                </li>
              </ul>
            </Collapse>
          </li>

          <li className={`sidebar-item  ${isActive('/video-management')}`}>
            <Link to="/video-management" className="sidebar-link">
              <FontAwesomeIcon icon={faVideoCamera} />
              <span className="align-middle">動画管理</span>
            </Link>
          </li>

          <li className={`sidebar-item  ${isActive('/notification-management')}`}>
            <Link to="/notification-management" className="sidebar-link">
              <i className="fa-solid fa-circle-exclamation fa-fw" />
              <span className="align-middle">お知らせ設定</span>
            </Link>
          </li>

          <li className="sidebar-header py-0"><hr /></li>

          <li className="sidebar-item" onClick={handleLogoutModalOpen}>
            <a href="#" className="sidebar-link">
              <i className="fa-solid fa-door-open fa-fw" />
              {' '}
              <span className="align-middle">ログアウト</span>
            </a>
          </li>

        </ul>
      </div>
    </nav>
  );
};

export default SideBar;
